<script setup>
import { widgetPrefixRegex } from '@/core/router/constants'

const { isMobile } = useDeviceType()
const { isWidget } = useWidgetSettings()
const { routePath } = useRoutePath()

const nonWidgetRoute = computed(() => routePath.value.replace(widgetPrefixRegex, ''))
const { t } = useI18n()
</script>

<template>
  <div
    v-if="isWidget && isMobile"
    class="mx-4"
  >
    <a
      id="widget-mobile-link"
      :href="nonWidgetRoute"
      target="_blank"
      class="btn-md w-full flex items-center justify-center flex-gap-x-2 fw-600 btn-fill-info"
    >
      <DSIcon
        icon="i-fas-mobile-notch"
        size="24"
      />
      {{ t('Switch to mobile version') }}
    </a>
  </div>
</template>

<i18n>
{
  "en-us": {
    "Switch to mobile version": "Switch to mobile version"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Switch to mobile version": "Zur mobilen Version wechseln"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Switch to mobile version": "Passer à la version mobile"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Switch to mobile version": "Cambia a versión para móviles"
}
</i18n>
